/**
 * 字符串中包含表情
 * @param str
 */
export function hasEmoji(str: string) {
  const reg = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi;
  return reg.test(str);
}
/**
 * 字符串中包含空格
 * @param str
 */
export function hasEmpty(str: string) {
  var reg = /\s/gi;
  return reg.test(str);
}
/**
 * 字符串中包含中文
 * @param str
 */
export function hasChinese(str: string) {
  const reg = /[\u4E00-\u9FA5]/gi;
  return reg.test(str);
}
/**
 * 字符串中是否只包含中文数字大小写字母
 * @param str
 */
export function onlyLetterNumberChinese(str: string) {
  const reg = /^[a-zA-Z\d\u4e00-\u9fa5]+$/;
  return reg.test(str);
}

/**
 * 字符串中是否只包含数字大小写字母
 * @param str
 */
export function onlyLetterNumber(str: string) {
  const reg = /^[a-zA-Z\d]+$/;
  return reg.test(str);
}

/**
 * 字符串中是否只包含中文数字大小写字母
 * @param str
 */
export function onlyLetterChinese(str: string) {
  const reg = /^[a-zA-Z\u4e00-\u9fa5]+$/;
  return reg.test(str);
}

/**
 *  字符串字节数
 * @param str
 */
export function getStrByteLength(str: string) {
  let realLength = 0;
  const len = str.length;
  for (let i = 0; i < len; i += 1) {
    const cValue = str.charAt(i);
    if (cValue.match(/[^\x00-\xff]/gi) != null || (cValue >= 'A' && cValue <= 'Z')) {
      realLength += 2;
    } else {
      realLength += 1;
    }
  }
  return realLength;
}

export function getStringByLength(str: string, length: number) {
  if (checkStringLength(str, length)) {
    let newStr = '';
    for (const char of str) {
      if (checkStringLength(newStr + char, length - 2)) {
        break;
      } else {
        newStr += char;
      }
    }
    return newStr + '...';
  }
  return str;
}
export function checkStringLength(str: string, length: number) {
  // true 代表超出长度，false代表未超出长度
  return getStringLength(str) > length;
}
export function getStringLength(str: string) {
  // 先把中文替换成两个字节的英文，在计算长度
  return str.replace(/[\u0391-\uFFE5]/g, 'aa').length;
}
/**
 * 获取字符串长度（汉字占两个长度）
 *
 * @export
 * @param {string} str
 * @returns
 */
export function getBigLen(str: string): number {
  if (str == null) {
    return 0;
  }
  // 把双字节的替换成两个单字节的然后再获得长度
  return str.replace(/[^\x00-\xff]/g, '**').length;
}
/**
 * 截取指定长度的字符串（中文占2个字符，英文1个字符）
 * @param str
 * @param len
 * @returns {*}
 */
export function bigSubstring(str: string = '', len: number = 0): string {
  const reg = /[^\x00-\xff]/gi;
  if (getBigLen(str) <= len) {
    return str;
  }
  const sLen = Math.floor(len / 2);
  for (let i = sLen; i < str.length; i += 1) {
    if (str.substr(0, i).replace(reg, '**').length >= len) {
      return str.substr(0, i);
    }
  }
  return str;
}
